<script setup>
import { cn } from "@/lib/utils";
import { DropdownMenuItem, useForwardProps } from "reka-ui";
import { computed } from "vue";

const props = defineProps({
  inset: {
    type: Boolean,
    default: false,
  },
  class: {
    type: [String, Array, Object],
    default: "",
  },
});

const delegatedProps = computed(() => {
  // eslint-disable-next-line no-unused-vars
  const { class: _, ...delegated } = props;
  return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <DropdownMenuItem
    v-bind="forwardedProps"
    :class="
      cn(
        'vf-relative vf-flex vf-cursor-default vf-select-none vf-items-center vf-rounded-sm vf-gap-2 vf-px-2 vf-py-1.5',
        'vf-text-sm vf-outline-none vf-transition-colors focus:vf-bg-accent',
        'data-[disabled]:vf-pointer-events-none data-[disabled]:vf-opacity-50 [&>svg]:vf-size-4 [&>svg]:vf-shrink-0',
        props.inset && 'vf-pl-8',
        props.class
      )
    "
  >
    <slot />
  </DropdownMenuItem>
</template>
